import { Observable } from 'rxjs';
import { CardRedeem } from '../models/card-redemm.model';

export abstract class CardRedeemRepository {
    abstract postCardRedeem<T>(card: CardRedeem): Observable<T>;
    abstract postCardRedeemB2B<T>(card: CardRedeem): Observable<T>;
    abstract postCardRedeemMP<T>(card: CardRedeem): Observable<T>;
}
